import { render } from "./select-component.vue?vue&type=template&id=3c9a8f79"
import script from "./select-component.vue?vue&type=script&lang=js"
export * from "./select-component.vue?vue&type=script&lang=js"

import exportComponent from "/Users/erdoganyesil/Sites/Fungi Turkey/FungiTurkey-Admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__